import { withNavigationWatcher } from '@core/components/src/withNavLayout/withNavLayout';

// const defaultRoles = [1, 2];
const defaultRoles = [1];

const getTags = (item, tags) => {
  if (tags) {
    return [...tags, item.text];
  }

  return [item.text];
};

export const getNavItems = (navs, tags, i18nT) => {
  return navs
    .filter((x) => !x.hide)
    .map((e) => {
      let itemRoles = e.roles;

      const tlPre = e.translationsPre || '';

      if (e.text) {
        const newText = e.shouldNotTranslate
          ? e.text
          : i18nT(e.text, { skipPre: true });

        e.text = newText.replace(tlPre, '');
      }

      if (e.tooltip) {
        e.tooltip = i18nT(e.tooltip, { skipPre: true }).replace(tlPre, '');
      }

      // if (e.roles) {
      //   if (e.roles.length === 0) {
      //     // itemRoles = [...defaultRoles];
      //   }
      //   // else {
      //   //   itemRoles = [...defaultRoles, ...e.roles];
      //   // }
      // }
      // else {
      //   itemRoles = [...defaultRoles];
      // }


      if (e.component) {
        e.component = withNavigationWatcher(e.component);
      }

      if (tags) {
        e.tags = tags;
      }

      if (e.items) {
        const tagsToAppend = getTags(e, tags);

        e.items = getNavItems(e.items, tagsToAppend, i18nT);
      }

      return { ...e, roles: itemRoles };
    });
};